import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import cronLogo from '../assets/cron-labs-logo.jpeg';

const API_URL = process.env.REACT_APP_API_ENDPOINT;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await axios.post(`${API_URL}/api/accounts/forgot-password/`, {
        email,
      });
      if (response.data.message) {
        setSuccess(true);
      }
    } catch (err) {
      console.error('Password reset error:', err);
      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else {
        setError('Failed to send reset email. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
      <img src={cronLogo} alt="Logo" className="w-10 mb-4 mt-4" />
      <form
        className="bg-white rounded-xl shadow p-8 w-full max-w-md flex flex-col gap-4"
        onSubmit={handleSubmit}
      >
        <h2 className="text-xl font-bold mb-2 text-center">Reset your password</h2>
        <p className="text-sm text-gray-600 text-center mb-4">
          Enter your email address and we'll send you instructions to reset your password.
        </p>
        <div>
          <label className="block font-semibold mb-1">Email</label>
          <input
            type="email"
            className="border rounded px-3 py-2 w-full"
            placeholder="Enter your email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        </div>
        {error && <div className="text-red-500 text-sm text-center">{error}</div>}
        {success && (
          <div className="text-green-500 text-sm text-center">
            Password reset instructions have been sent to your email.
          </div>
        )}
        <button
          type="submit"
          className="bg-indigo-600 text-white rounded px-6 py-2 w-full mt-2 font-semibold disabled:opacity-60"
          disabled={loading}
        >
          {loading ? 'Sending...' : 'Send Reset Instructions'}
        </button>
        <button
          type="button"
          onClick={() => navigate('/login')}
          className="text-indigo-600 hover:underline text-sm"
        >
          Back to Login
        </button>
      </form>
    </div>
  );
};

export default ForgotPassword; 